import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Download: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[24px] h-[24px] stroke-[2px]', className)}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
  >
    <path d="M19 18.3254C19.9282 18.3254 20.8185 17.9566 21.4749 17.3003C22.1312 16.6439 22.5 15.7536 22.5 14.8254C22.5 13.8971 22.1312 13.0069 21.4749 12.3505C20.8185 11.6941 19.9282 11.3254 19 11.3254H18C18.1459 10.6753 18.1481 10.0058 18.0065 9.35499C17.8649 8.70417 17.5823 8.08483 17.1748 7.53232C16.7672 6.97981 16.2427 6.50496 15.6313 6.13487C15.0198 5.76478 14.3334 5.50671 13.6111 5.37539C12.8888 5.24407 12.1449 5.24207 11.4218 5.3695C10.6986 5.49694 10.0105 5.75131 9.39658 6.11811C8.15675 6.85887 7.29467 8.01257 6.99999 9.32539C5.93394 9.28269 4.88553 9.59579 4.03426 10.2111C3.18299 10.8264 2.58181 11.7056 2.33366 12.6982C2.08551 13.6908 2.20582 14.7351 2.67399 15.6522C3.14216 16.5693 3.92907 17.3022 4.89999 17.7254M12 13.3254V22.3254M12 22.3254L9 19.3254M12 22.3254L15 19.3254" stroke="#354052" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default Download;
